module.exports = __webpack_public_path__ + "img/domain-banner-influence.351fdad0.svg";